import { isEmptyValue } from 'Helpers'
import { FormErrors, FormValues } from 'Pages/ibro'

export const checkRequiredFields = (formValues: FormValues, requiredFields?: string[]) => {
	const fields = requiredFields ?? Object.keys(formValues)
	return !fields.some((key: string) => {
		return isEmptyValue(formValues[key])
	})
}

export const formErrorState = (fieldErrors: FormErrors, fieldNames?: string[]) => {
	const errors = fieldNames ?? Object.keys(fieldErrors)
	return errors.some((field: string) => Boolean(fieldErrors[field]))
}

export const onlyRequiredErrorState = <T = FormErrors>(formValues: FormValues, formErrors: T) => {
	return Object.keys(formErrors).some(
		(field: string) => formErrors[field] && !isEmptyValue(formValues[field])
	)
}
